import { startCase } from "lodash-es";
import type { IssueWithAssetRegister } from "../../../kubb";

export function issueCategoryFormatter(issue: IssueWithAssetRegister): string {
  const [group, specific] = issue.category.split(".");
  return `${startCase(group.toLowerCase())}: ${startCase(specific.toLowerCase())}`;
}
